export default __webpack_public_path__ + "static/media/wTop_2_c2.f65e6f82.jpeg";